import type {
  AdminCancelOrderPayloadEntity,
  UnavailableItemDurationEntity
} from '../entities/AdminCancelOrderPayloadEntity'

export function buildAdminCancelOrderPayload({
  cancelOrderReasonId,
  requiresUnavailableItems,
  unavailableItems,
  allowedItemIds
}: AdminCancelOrderPayloadEntity & { allowedItemIds?: number[] }): {
  payload?: {
    cancelOrderReasonId: number
    unavailableItems?: UnavailableItemDurationEntity[]
  }
  errorMessage?: string
} {
  if (cancelOrderReasonId === undefined || cancelOrderReasonId === null) {
    return { errorMessage: 'Cancel reason is required.' }
  }

  const selectedUnavailableItems = requiresUnavailableItems ? (unavailableItems ?? []) : []

  if (requiresUnavailableItems && selectedUnavailableItems.length === 0) {
    return { errorMessage: 'Please select at least one unavailable item.' }
  }

  if (selectedUnavailableItems.length > 0) {
    const selectedIds = new Set<number>()
    const allowedIds = new Set<number>(allowedItemIds ?? [])

    for (const item of selectedUnavailableItems) {
      if (!item.itemId) {
        return { errorMessage: 'Please select valid unavailable items.' }
      }
      if (selectedIds.has(item.itemId)) {
        return { errorMessage: 'Duplicate unavailable items are not allowed.' }
      }
      selectedIds.add(item.itemId)

      if (
        !Number.isInteger(item.unavailableDurationHours) ||
        item.unavailableDurationHours < 1 ||
        item.unavailableDurationHours > 24
      ) {
        return { errorMessage: 'Unavailable duration must be an integer between 1 and 24.' }
      }

      if (allowedIds.size > 0 && !allowedIds.has(item.itemId)) {
        return { errorMessage: 'Selected item does not belong to this order.' }
      }
    }
  }

  return {
    payload: {
      cancelOrderReasonId,
      ...(selectedUnavailableItems.length > 0
        ? { unavailableItems: selectedUnavailableItems }
        : {})
    }
  }
}
